<template>
  <v-container fluid class="pa-0 ma-8">
    <v-flex d-flex child-flex>
      <v-row dense>
        <v-col v-for="report in reports" :key="report.key" cols="12" md="4">
          <ReportCard :report="report" />
        </v-col>
      </v-row>
    </v-flex>
    <!-- <v-btn
      :href="this.$router.resolve({ name: 'report1Admin' }).href"
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
    >
      استهلاك زبون
    </v-btn>
    <v-btn
      :href="this.$router.resolve({ name: 'report2Admin' }).href"
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
    >
      استهلاك عداد
    </v-btn>
    <v-btn
      :href="this.$router.resolve({ name: 'report3Admin' }).href"
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
    >
      جميع العدادات
    </v-btn>
    <v-btn
      :href="this.$router.resolve({ name: 'report4Admin' }).href"
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
    >
      الصناديق
    </v-btn> -->
  </v-container>
</template>

<script>
import ReportCard from "@/components/ReportCard.vue";

export default {
  components: { ReportCard },
  data: () => ({
    reports: [
      { id: 1, name: "report1Admin", path: "/report1", title: "استهلاك زبون" },
      { id: 2, name: "report2Admin", path: "/report2", title: "اسنهلاك عداد" },
      { id: 3, name: "report3Admin", path: "/report3", title: "جميع العدادات" },
      { id: 4, name: "report4Admin", path: "/report4", title: "الصناديق" },
      {
        id: 5,
        name: "report5Admin",
        path: "/report5",
        title: "الزبائن والعدادات",
      },
      {
        id: 6,
        name: "report6Admin",
        path: "/report6",
        title: " مجاميع الاستهلاك",
      },
      {
        id: 7,
        name: "report7Admin",
        path: "/report7",
        title: "الفروقات",
      },
    ],
  }),
  computed: {},
  methods: {},
};
</script>
